import gql from 'graphql-tag';

export const removeEvaluationMutation = gql`
  mutation RemoveEvaluation($id: ID!) {
    removeEvaluation(id: $id)
  }
`;